import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { api } from '@/lib/api';
import { toast } from 'sonner';
import SEO from '@/components/SEO';

const ResetPassword = () => {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const nav = useNavigate();
  const [state, setState] = useState({ checking: true, valid: false, email: '' });
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!token) { setState({ checking: false, valid: false, email: '' }); return; }
    api.get(`/auth/reset-password/validate?token=${encodeURIComponent(token)}`)
      .then(({ data }) => setState({ checking: false, valid: !!data.valid, email: data.email || '' }))
      .catch(() => setState({ checking: false, valid: false, email: '' }));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) { toast.error('Password must be at least 6 characters'); return; }
    if (pw !== pw2) { toast.error('Passwords do not match'); return; }
    setSaving(true);
    try {
      await api.post('/auth/reset-password', { token, new_password: pw });
      toast.success('Password reset. Please sign in.');
      nav('/login', { replace: true });
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Reset failed');
    } finally { setSaving(false); }
  };

  return (
    <>
      <SEO title="Set new password" noindex />
      <div className="min-h-[calc(100vh-5rem)] bg-sans_bone flex items-center">
        <div className="sans-container max-w-md py-16">
          <div className="sans-label mb-3">Set new password</div>
          {state.checking ? (
            <div className="text-sans_mute">Verifying link…</div>
          ) : !state.valid ? (
            <>
              <h1 className="font-serif text-3xl text-sans_ink">This link is invalid or expired.</h1>
              <p className="sans-body mt-4">Reset links are valid for 30 minutes and can only be used once. Please request a fresh one.</p>
              <Link to="/forgot-password" className="sans-btn-primary mt-8 inline-block">Request new link</Link>
            </>
          ) : (
            <>
              <h1 className="font-serif text-3xl text-sans_ink">Choose a new password.</h1>
              <p className="text-sm text-sans_mute mt-4">for <strong className="text-sans_ink">{state.email}</strong></p>
              <form onSubmit={submit} className="mt-8 space-y-6">
                <div>
                  <label className="sans-label block mb-2">New password</label>
                  <input data-testid="reset-pw" className="sans-input" type="password" required minLength={6} value={pw} onChange={(e) => setPw(e.target.value)} placeholder="Minimum 6 characters" />
                </div>
                <div>
                  <label className="sans-label block mb-2">Confirm new password</label>
                  <input data-testid="reset-pw2" className="sans-input" type="password" required value={pw2} onChange={(e) => setPw2(e.target.value)} />
                </div>
                <button data-testid="reset-submit" disabled={saving} className="sans-btn-primary w-full">{saving ? 'Saving…' : 'Set new password'}</button>
              </form>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
